import { useTranslation } from 'react-i18next'
import { Alpha3Code } from 'i18n-iso-countries'

import { CardContent } from '@percent/lemonade'
import { PaymentMethod } from '@percent/admin-dashboard/api/types'
import { ExternalLink } from '@percent/admin-dashboard/common/components/externalLink/ExternalLink'
import { PaymentTypeWithButton } from './PaymentTypeWithButton'

export function CardView({
  paymentMethod,
  refresh,
  organisationCountryCode
}: Readonly<{
  paymentMethod: PaymentMethod
  refresh: VoidFunction
  organisationCountryCode: Alpha3Code
}>) {
  const { t } = useTranslation()

  return (
    <>
      <PaymentTypeWithButton
        title={t('typography.paymentMethod')}
        text={t('typography.card')}
        paymentMethod={paymentMethod}
        refresh={refresh}
        organisationCountryCode={organisationCountryCode}
      />
      <CardContent title={t('typography.paymentUrl')} testId="card-details-payment-url">
        {(paymentMethod.paymentUrl && (
          <ExternalLink
            height="24px"
            width="24px"
            url={paymentMethod.paymentUrl}
            text={paymentMethod.paymentUrl.replace(/^https?:\/\//, '')}
          />
        )) ||
          t('typography.notAvailable')}
      </CardContent>
    </>
  )
}
